import React, { ChangeEvent, FC, ReactNode, useState } from 'react';
import { Button } from '@material-ui/core';
import { FieldProps, Form } from 'formik';
import { useTranslation } from 'react-i18next';

import {
  ActionContainer,
  FormikEffect,
  SubmitButton,
  ValidatedTextField,
  VisibilityAdornment,
} from 'components';
import { Login } from 'Links';

import { ISignUpValues } from '../validations';
import Terms from './Terms';

interface IProps {
  updateUsername: (username: string) => void;
  updatePassword: (password: string) => void;
  sidebar: ReactNode;
  working: boolean;
  hiddenEmail?: boolean;
}

const SignUpForm: FC<IProps> = props => {
  const { hiddenEmail, sidebar, working, updateUsername, updatePassword } = props;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { t } = useTranslation();

  function handleChange({ username, password }: ISignUpValues) {
    updateUsername(username.toLowerCase());
    updatePassword(password);
  }

  return (
    <Form>
      <FormikEffect onChange={handleChange} delay={100} />
      {sidebar}
      {!hiddenEmail && (
        <ValidatedTextField
          name="username"
          i18nKey="user:email"
          onChange={(
            event: ChangeEvent<HTMLInputElement>,
            onChange: FieldProps['field']['onChange'],
          ) => {
            event.target.value = event.target.value.trim();
            onChange(event);
          }}
        />
      )}
      <ValidatedTextField
        name="password"
        type={passwordVisible ? 'text' : 'password'}
        i18nKey="auth:signUpPassword"
        InputProps={{
          endAdornment: (
            <VisibilityAdornment
              visible={passwordVisible}
              onToggle={() => setPasswordVisible(!passwordVisible)}
            />
          ),
        }}
      />
      <Terms />
      <ActionContainer>
        <SubmitButton working={working} text={t('auth:signUpButton')} />
        <Button component={Login} fullWidth>
          {t('auth:signUpLogin')}
        </Button>
      </ActionContainer>
    </Form>
  );
};

export default SignUpForm;
